import actions from './actions'
import getters from './getters'
import mutations from './mutations'

// initial state
const state: appbase.state.AppbaseState = {
  modal: null,
  teams: false,
  loadingBarMessage: '',
  page: {
    current: Object.create(null),
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}
